import React from 'react';
import {useTitleTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import styles from '@dazn/lp-web/src/components/FeaturesV2/featuresv2.module.css';
import StaticImage from '@dazn/lp-web/src/components/Images/ImageComponent/Image';
import Markdown from 'markdown-to-jsx';
import {animated} from '@react-spring/web';
import {IBenefit} from '@dazn/lp-web/src/types/benefits.types';

interface IProps {
    data: any;
    key: number;
    disableAnimation: boolean;
}

function FeatureV2Item({
    featureItem,
    key
}: {
    featureItem: IBenefit;
    key: string;
}) {
    const {title, description} = featureItem;
    return (
        <div key={key} className={styles.featureItemContainer}>
            <Markdown className={styles.title}>{title}</Markdown>
            <Markdown className={styles.description}>{description}</Markdown>
        </div>
    );
}

const FeaturesV2: React.FC<IProps> = ({data, disableAnimation, key}) => {
    const {features, image, title, componentType} = data;

    const [refView, springs] = useTitleTransitions();

    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    return (
        <div className={styles.featuresContainer} key={key}>
            <StaticImage
                image={image}
                alt={componentType}
                componentType={componentType}
                showPlaceHolderImage={true}
            />
            <animated.div {...animations} className={styles.contentContainer}>
                <Markdown className={styles.featuresTitle}>{title}</Markdown>
                <div className={styles.featuresList}>
                    {features?.map(
                        (
                            featureItem: IBenefit,
                            index: React.Key | null | undefined
                        ) => (
                            <FeatureV2Item
                                featureItem={featureItem}
                                key={`feature-v2-item-${index}`}
                            />
                        )
                    )}
                </div>
            </animated.div>
        </div>
    );
};

export default FeaturesV2;
